import { render, staticRenderFns } from "./reports.vue?vue&type=template&id=736b1e64&scoped=true&"
import script from "./reports.ts?vue&type=script&lang=ts&"
export * from "./reports.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736b1e64",
  null
  
)

export default component.exports